module.exports = __webpack_public_path__ + "assets/img/Structure_item6.7f3b9906.png";